import i18n from 'i18next';

type statusOptions = {
  key: number;
  value: string;
  styled: string;
};

export const AccountsStatus: Array<statusOptions> = [
  {
    key: 1,
    get value() {
      return i18n.t('account.temporary');
    },
    styled: 'colorOrange'
  },
  {
    key: 2,
    get value() {
      return i18n.t('account.permanent');
    },
    styled: 'colorGreen'
  },
  {
    key: 3,
    get value() {
      return i18n.t('account.deactivate');
    },
    styled: 'colorRed'
  },
  {
    key: 4,
    get value() {
      return i18n.t('account.closed');
    },
    styled: 'colorRed'
  },
  {
    key: 5,
    get value() {
      return i18n.t('account.forbidden');
    },
    styled: 'colorRed'
  },
  {
    key: 6,
    get value() {
      return i18n.t('account.blocked');
    },
    styled: 'colorRed'
  }
];
